import { render } from "./index.vue?vue&type=template&id=cb0f9bea&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=cb0f9bea&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=cb0f9bea&lang=scss"
script.render = render
script.__scopeId = "data-v-cb0f9bea"

export default script